import Styles from './TeacherCards.scss';

import Template from './TeacherCards.hbs';
import GroupCard from './groupCard/GroupCard';
import AddGroupCard from './addGroupCard/AddGroupCard';
import NewsCard from './newsCard/NewsCard';
import NewsList from './newsCard/newsList/NewsList';
import Dropdown from 'views/components/dropdown/Dropdown.svelte';
import EditFavoriteModal from 'views/pages/users/home/editFavoriteModal/EditFavoriteModal.svelte';
import RestoreGroupModal from 'views/pages/users/settings/restoreGroupModal/RestoreGroupModal';

export default BaseView.extend({

    initialize() {

        // Set the default element
        this.setElement(Template({Styles}));

        // Show news for all teachers
        this.renderNews()

        this.hasFavoriteGroups = !!Backbone.Collection.groups.findWhere({ is_favorite: true })

        // Show a card to create a new group. Excludes demo users, the mobile version
        const showAddGroupCard = !Backbone.Model.user.get('is_demo') && !ISMOBILE

        const hasOtherGroups = !!Backbone.Collection.groups.findWhere({ is_favorite: false })

        // Set headers for groups
        if (this.hasFavoriteGroups) {
            this.$('.js-favorite-header').text(window.i18n.gettext('Favorites'))

            // The "My groups" section also holds the add-group card, so show its header
            // whenever that card will be shown, even if there are no other groups yet.
            if (hasOtherGroups || showAddGroupCard) {
                this.$('.js-header').text(window.i18n.gettext('My groups'))
            }
        } else {
            this.$('.js-header').text(window.i18n.gettext('My groups'))
        }

        if (!ISMOBILE) {
            this.renderActions()
        }

        // Render all group cards
        Backbone.Collection.groups.each((groupModel) => {
            this.renderGroupCard(groupModel)
        })

        if (showAddGroupCard) {
            this.addChildView(new AddGroupCard(), '.js-groups');
        }

        this.loadPendingActions()
    },

    /**
     * loadPendingActions
     *
     * Fetches the number of pending student requests / missing-credential students per
     * group, so each group card can show a request-indicator badge.
     */
    loadPendingActions() {
        $.getJSON('/users/get_groups_with_pending_actions.json', (response) => {
            _.each(response, (groupObject) => {
                const pendingActionCount = (groupObject.pending_students || 0) +
                    (groupObject.students_without_valid_email || 0)

                const groupModel = Backbone.Collection.groups.get(groupObject.id)
                if (groupModel) {
                    groupModel.set({ pendingActions: pendingActionCount })
                }
            })
        })
    },

    /**
     * renderActions
     *
     * Renders the "Actions" dropdown (edit favorites / add group / restore group)
     * next to whichever section header is shown on top - the favorites header when
     * there are favorite groups, otherwise the main "My groups" header.
     */
    renderActions() {

        const dropdownItems = []

        // Prevent adding/restoring groups for demo accounts
        if (!Backbone.Model.user.get('is_demo')) {
            dropdownItems.push({
                icon: 'plus-circle',
                label: window.i18n.gettext('Add a group'),
                callback: () => {
                    Backbone.history.navigate('groups/pick_course', { trigger: true })
                }
            })

            dropdownItems.push({
                icon: 'archive',
                label: window.i18n.gettext('Restore group'),
                callback: () => {
                    const archivedGroups = new Backbone.Collection()
                    archivedGroups.url = '/users/get_archived_groups.json'
                    Backbone.View.Components.modal.open(RestoreGroupModal, {
                        title: window.i18n.gettext('Which group do you want to restore?'),
                        fetchCollection: archivedGroups
                    })
                }
            })
        }

        // Teachers with more than 6 groups can choose favorite groups
        if (Backbone.Collection.groups.length > 6 || this.hasFavoriteGroups) {
            dropdownItems.push({
                icon: 'star-rounded',
                label: window.i18n.gettext('Edit favorites'),
                callback: () => {
                    this.addSvelteChildView(this.el, EditFavoriteModal)
                }
            })
        }

        if (!dropdownItems.length) {
            return
        }

        this.addSvelteChildView(this.hasFavoriteGroups ? '.js-favorite-actions' : '.js-actions', Dropdown, {
            buttonOptions: {
                label: window.i18n.gettext('Actions'),
                icon: 'three-dots',
                theme: 'secondary'
            },
            dropdownItems
        })
    },

    renderNews() {
        const messagesCollection = new Backbone.Collection(this.model.get('news'))
        if (!messagesCollection.length) {
            return
        }

        messagesCollection.each((model) => {
            this.addChildView(
                new NewsCard({
                    model
                }),
                '.js-news'
            )

            window.statsTracker.trackEvent(
                'News',
                'Show message on home',
                model.id
            )
        })

        this.$('.js-news-all').on('click', () => {
            Backbone.View.sidebar.showSidebar(
                new NewsList(),
                window.i18n.gettext('All messages'),
                520
            )
        })

        window.statsTracker.trackEvent(
            'News',
            'Show messages on home',
            messagesCollection.length
        )
    },

    renderGroupCard(groupModel) {

        // Find the results data for this group. If not present, skip rendering this group.
        const groupInfo = this.model.get('last_groups').find(lastGroup => lastGroup.results.group_id === groupModel.id)
        if (!groupInfo) {
            Backbone.Model.user.updateCollections()
            window.sentry.withScope(scope => {
                scope.setExtra('group', groupInfo);
                window.sentry.captureMessage('data_for_home.json has group_id not in global GroupsCollection');
            });
            return
        }

        // Create new card
        const container = groupModel.get('is_favorite') ? this.$('.js-favorite-groups') : this.$('.js-groups')
        this.addChildView(new GroupCard({
            model: groupModel,
            score: groupInfo.results.score,
            sections: groupInfo.results.sections || [],
            activities: groupInfo.results.activities || [],
            weeks: groupInfo.studyplanner ? groupInfo.studyplanner.weeks : undefined
        }), container)
    },
});
